
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class LoadingCircle extends Vue {
  @Prop({ default: 'white' })
  color: 'black' | 'white';
}
